export const GET_PROMOTIONS_START = 'GET_PROMOTIONS_START';
export const GET_PROMOTIONS_SUCCESS = 'GET_PROMOTIONS_SUCCESS';
export const GET_PROMOTIONS_FAILED = 'GET_PROMOTIONS_FAILED';
export const GET_SINGLE_PROMO_START = 'GET_SINGLE_PROMO_START';
export const GET_SINGLE_PROMO_SUCCESS = 'GET_SINGLE_PROMO_SUCCESS';
export const GET_SINGLE_PROMO_FAILED = 'GET_SINGLE_PROMO_FAILED';
export const GET_SINGLE_TEMPLATE_START = 'GET_SINGLE_TEMPLATE_START';
export const GET_SINGLE_TEMPLATE_SUCCESS = 'GET_SINGLE_TEMPLATE_SUCCESS';
export const GET_SINGLE_TEMPLATE_FAILED = 'GET_SINGLE_TEMPLATE_FAILED';
export const CANCEL_PROMOTION_START = 'CANCEL_PROMOTION_START';
export const CANCEL_PROMOTION_SUCCESS = 'CANCEL_PROMOTION_SUCCESS';
export const CANCEL_PROMOTION_FAILED = 'CANCEL_PROMOTION_FAILED';
export const GET_METADATA_START = 'GET_METADATA_START';
export const GET_METADATA_SUCCESS = 'GET_METADATA_SUCCESS';
export const GET_METADATA_FAILED = 'GET_METADATA_FAILED';
export const GET_REQUESTED_CUSTOM_PROMOTIONS_START = 'GET_REQUESTED_CUSTOM_PROMOTIONS_START';
export const GET_REQUESTED_CUSTOM_PROMOTIONS_SUCCESS = 'GET_REQUESTED_CUSTOM_PROMOTIONS_SUCCESS';
export const GET_REQUESTED_CUSTOM_PROMOTIONS_FAILED = 'GET_REQUESTED_CUSTOM_PROMOTIONS_FAILED';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const CREATE_PROMO_BY_TEMPLATE_START = 'CREATE_PROMO_BY_TEMPLATE_START';
export const CREATE_PROMO_BY_TEMPLATE_SUCCESS = 'CREATE_PROMO_BY_TEMPLATE_SUCCESS';
export const CREATE_PROMO_BY_TEMPLATE_FAILED = 'CREATE_PROMO_BY_TEMPLATE_FAILED';
export const RESCHEDULE_PROMOTION_START = 'RESCHEDULE_PROMOTION_START';
export const RESCHEDULE_PROMOTION_SUCCESS = 'RESCHEDULE_PROMOTION_SUCCESS';
export const RESCHEDULE_PROMOTION_FAILED = 'RESCHEDULE_PROMOTION_FAILED';


export const getPromotionsStart = () => ({
  type: GET_PROMOTIONS_START
});

export const getPromotionsSuccess = (data, status) => ({
  type: GET_PROMOTIONS_SUCCESS,
  data,
  status
});

export const getPromotionsFailed = () => ({
  type: GET_PROMOTIONS_FAILED
});

export const getSinglePromoStart = () => ({
  type: GET_SINGLE_PROMO_START
});

export const getSinglePromoSuccess = (data) => ({
  type: GET_SINGLE_PROMO_SUCCESS,
  data
});

export const getSinglePromoFailed = (error) => ({
  type: GET_SINGLE_PROMO_FAILED,
  error
});

export const getSingleTemplateStart = () => ({
  type: GET_SINGLE_TEMPLATE_START
});

export const getSingleTemplateSuccess = (data) => ({
  type: GET_SINGLE_TEMPLATE_SUCCESS,
  data
});

export const getSingleTemplateFailed = (error) => ({
  type: GET_SINGLE_TEMPLATE_FAILED,
  error
});

export const cancelPromoStart = (id) => ({
  type: CANCEL_PROMOTION_START,
  id
});

export const cancelPromoSuccess = (data) => ({
  type: CANCEL_PROMOTION_SUCCESS,
  data
});

export const cancelPromoFailed = (error, id) => ({
  type: CANCEL_PROMOTION_FAILED,
  error,
  id
});

export const reschedulePromoStart = (id) => ({
  type: RESCHEDULE_PROMOTION_START,
  id
});

export const reschedulePromoSuccess = (data) => ({
  type: RESCHEDULE_PROMOTION_SUCCESS,
  data
});

export const reschedulePromoFailed = (error, id) => ({
  type: RESCHEDULE_PROMOTION_FAILED,
  error,
  id
});

export const getMetadataStart = () => ({
  type: GET_METADATA_START
});

export const getMetadataSuccess = (data) => ({
  type: GET_METADATA_SUCCESS,
  data
});

export const getMetadataFailed = (error) => ({
  type: GET_METADATA_FAILED,
  error
});

export const getRequestedCustomPromotionsStart = () => ({
  type: GET_REQUESTED_CUSTOM_PROMOTIONS_START
});

export const getRequestedCustomPromotionsSuccess = (data) => ({
  type: GET_REQUESTED_CUSTOM_PROMOTIONS_SUCCESS,
  data
});

export const getRequestedCustomPromotionsFailed = () => ({
  type: GET_REQUESTED_CUSTOM_PROMOTIONS_FAILED
});

export const setActiveTab = (data) => ({
  type: SET_ACTIVE_TAB,
  data
});

export const createPromoByTemplateStart = (id) => ({
  type: CREATE_PROMO_BY_TEMPLATE_START,
  id
});

export const createPromoByTemplateSuccess = (data) => ({
  type: CREATE_PROMO_BY_TEMPLATE_SUCCESS,
  data
});

export const createPromoByTemplateFailed = (error, id) => ({
  type: CREATE_PROMO_BY_TEMPLATE_FAILED,
  error,
  id
});
